var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var Helpers;
(function (Helpers) {
    /**
     * Given an Array that could be a list of strings, or a single element with an array, or a function
     * that's a filter, return a sequence of [key, value] pairs for each propery/value on the object
     *
     * @param {any} source The object from which to obtain props
     * @param {...any} args The args list: a single array, or a sequence of strings, or missing to retrieve all properties
     * @returns {Array<Kvp>} an array of key/value pairs containing the name & value
     */
    function propValuesForArgList(source) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var propNames = getArgList(args);
        if (typeof propNames === "function") {
            // Adapted from iter8 library that we barely used.  I don't know if this function or code branch is even used anywhere.  If I broke something, I apologize!
            return Array.from(new Set(getAllProps(source).filter(function (p) { return p !== "constructor" && propNames(p); }))).map(function (k) { return [k, source[k]]; });
        }
        else {
            return propNames.filter(function (prop) { return !!source[prop]; }).map(function (prop) {
                return [prop, source[prop]];
            });
        }
    }
    Helpers.propValuesForArgList = propValuesForArgList;
    function getAllProps(obj) {
        var props = Object.getOwnPropertyNames(obj);
        var parentProto = Object.getPrototypeOf(obj);
        if (parentProto !== Object.prototype) {
            props = __spreadArrays(props, getAllProps(parentProto));
        }
        return props;
    }
    /**
     * Given an array of unknown contents (could be strings, could be a single element that's also an array)
     * return a clean array. This is useful for parsing ...args that allows users to pass an array of final args,
     * or just more args.
     *
     * If it's a single arg, and it's not an array, then the arg itself is returned.
     *
     * @param {any} args The arguments to parts
     * @returns {Array} an array of arguments, or the single non-array argument.
     */
    function getArgList(args) {
        if (args.length === 0) {
            // make a pass-thru filter if no args
            return function () {
                return true;
            };
        }
        else if (args.length === 1 &&
            (Array.isArray(args[0]) || typeof args[0] !== "string"))
            return args[0];
        else
            return args;
    }
    Helpers.getArgList = getArgList;
    /**
     * Test whether and entity is a plain javascript object; e.g. is truthy, type = 'object' and isn't an array.
     *
     * @param {any} obj The entity to test
     * @returns {boolean} true if a plain object
     */
    function isObject(obj) {
        return obj && !Array.isArray(obj) && typeof obj === "object";
    }
    Helpers.isObject = isObject;
    /**
     * Determines if the object is one of the object types that does not have properties,
     * such as a Date or RegExp object. Note that this does not include empty objects.
     * @param {any} obj The entity to test
     * @return {boolean} True if the object is one of the property-less objects
     */
    function isPropertyLessObject(obj) {
        return isObject(obj) && (obj instanceof Date || obj instanceof RegExp);
    }
    Helpers.isPropertyLessObject = isPropertyLessObject;
    /**
     * Clone an object recursively. Arrays and child objects are reconstructed, and will not have reference
     * equality with the original. Other types are copied, and reference types will be reference equal to the
     * original.
     *
     * @param {any} obj The thing to clone
     * @returns {any} a clone of thing
     */
    function clone(obj) {
        if (Array.isArray(obj)) {
            return obj.map(clone);
        }
        else if (isPropertyLessObject(obj)) {
            return obj;
        }
        else if (isObject(obj)) {
            return Object.keys(obj).reduce(function (last, cur) {
                last[cur] = clone(obj[cur]);
                return last;
            }, {});
        }
        else {
            return obj;
        }
    }
    Helpers.clone = clone;
    /**
     * Test of object has any properties at all. This will include prototypes - so it may not be
     * the best idea except with simple objects
     *
     * @param {any} obj
     * @returns {boolean} True if the object has any properties
     */
    function hasProperties(obj) {
        // this is probably the fastest way to test if an object has any properties.
        /*eslint no-unused-vars: 0 */
        for (var prop in obj) {
            return true;
        }
        return false;
    }
    Helpers.hasProperties = hasProperties;
    /**
     * Test if two objects are actually equal (accounting for NaN)
     *
     * @param {any} val1
     * @param {any} val2
     * @returns
     */
    function isEqual(val1, val2) {
        // the 2nd clause is to prevent NaN !== NaN. The only real way to test NaN is when value !== value
        return val1 === val2 || (val1 !== val1 && val2 !== val2);
    }
    Helpers.isEqual = isEqual;
})(Helpers || (Helpers = {}));
export default Helpers;
//# sourceMappingURL=utility.js.map